module.exports = __webpack_public_path__ + "img/dep-just-sky-l.374c85f8.jpg";